// import wx from 'weixin-js-sdk'
// import payPublic from './payPublic'
const mapUtil = {
    map: new AMap.Map("container", {}),
    geolocation: null,
    isWeixin: function () {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    },
    MyLocalStorage: {
        Cache: {
            /**
             * 总容量5M
             * 存入缓存，支持字符串类型、json对象的存储
             * 页面关闭后依然有效 ie7+都有效
             * @param key 缓存key
             * @param stringVal
             * @time 数字 缓存有效时间（秒） 默认60s
             * 注：localStorage 方法存储的数据没有时间限制。第二天、第二周或下一年之后，数据依然可用。不能控制缓存时间，故此扩展
             * */
            put: function (key, stringVal, time) {
                try {
                    if (!localStorage) { return false; }
                    if (!time || isNaN(time)) { time = 60; }
                    var cacheExpireDate = (new Date() - 1) + time * 1000;
                    var cacheVal = { val: stringVal, exp: cacheExpireDate };
                    localStorage.setItem(key, JSON.stringify(cacheVal));//存入缓存值
                } catch (e) { }
            },
            /**获取缓存*/
            get: function (key) {
                try {
                    if (!localStorage) { return false; }
                    var cacheVal = localStorage.getItem(key);
                    var result = JSON.parse(cacheVal);
                    var now = new Date() - 1;
                    if (!result) { return null; }//缓存不存在
                    if (now > result.exp) {//缓存过期
                        this.remove(key);
                        return "";
                    }
                    return result.val;
                } catch (e) {
                    this.remove(key);
                    return null;
                }
            },/**移除缓存，一般情况不手动调用，缓存过期自动调用*/
            remove: function (key) {
                if (!localStorage) { return false; }
                localStorage.removeItem(key);
            },/**清空所有缓存*/
            clear: function () {
                if (!localStorage) { return false; }
                localStorage.clear();
            }
        }
    },
    wxlocate: function (succ_CallBack, error_CallBack) {
        wx.ready(function () {
            wx.getLocation({
                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function (res) {
                    AMap.service('AMap.Geocoder', function () {//回调函数
                        var geocoder = new AMap.Geocoder({});
                        geocoder.getAddress([res.longitude, res.latitude], function (status, result) {
                            if (status === 'complete' && result.info === 'OK') {
                                var position = { position: {}, addressComponent: {} };
                                position.position.lat = res.latitude;
                                position.position.lng = res.longitude;
                                position.addressComponent = result.regeocode.addressComponent;

                                position.location = position.position
                                position.adcode = position.addressComponent.adcode
                                succ_CallBack(position);
                            }
                        });
                    })
                },
                fail: function (err) {
                    let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    if (isiOS && err.errMsg == "getLocation:fail") {
                        payPublic.showPrompt('您需要打开定位权限，才可以正常使用。请到设置->隐私->定位服务中开启。')
                    }
                }
            });
        });
    },
    getLocalCity: function (LocalCity_CallBack) {
        new AMap.CitySearch().getLocalCity(function (status, result) {

            if (status === 'complete' && result.info === 'OK') {
                if (result && result.city && result.bounds) {
                    var cityPosition = result;
                    var geocoder = new AMap.Geocoder({
                        city: result.adcode, //城市，默认：“全国”
                        radius: 1000 //范围，默认：500
                    }).getLocation(result.city, function (status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                            var position = result.geocodes[0];
                            position.position = position.location;
                            position.addressComponent.adcode = position.adcode;
                            if (LocalCity_CallBack) {
                                LocalCity_CallBack(position);
                            }
                        }
                    });
                }
            } else {
                if (LocalCity_CallBack) {
                    LocalCity_CallBack();
                }
            }
        });
    },
    getGeolocation: function () {
        var geolocation;
        this.map.plugin('AMap.Geolocation', function () {
            if (geolocation == null) {
                geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true,//是否使用高精度定位，默认:true
                    timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                    maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                    convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                    showButton: false,        //显示定位按钮，默认：true
                    buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
                    buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: false,     //定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: false,     //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    GeoLocationFirst: true		//默认为false，设置为true的时候可以调整PC端为优先使用浏览器定位，失败后使用IP定位
                });
            }
            // return geolocation;
        });
        return geolocation
    },
    locate: function (succ_CallBack, error_CallBack) {
        var me = this;
        var position = this.MyLocalStorage.Cache.get("position");

        if (position) {
            position = JSON.parse(position);
            succ_CallBack(position);
        }
        // else if (me.isWeixin()) {
        //     this.wxlocate(function (position) {
        //         me.MyLocalStorage.Cache.put("position", JSON.stringify(position), 3 * 60);
        //         succ_CallBack(position);
        //     });
        // }
        else {

            var interval = window.setInterval(function () {
                var geolocation = me.getGeolocation();

                //定位
                if (geolocation) {
                    clearInterval(interval);
                    geolocation.getCurrentPosition();
                    var completeListener = AMap.event.addListener(geolocation, 'complete', function (d) {

                        var data = d;
                        d.location = d.position
                        // d.adcode = d.addressComponent.adcode
                        me.MyLocalStorage.Cache.put("position", JSON.stringify(data), 30 * 60);
                        succ_CallBack(data);
                        AMap.event.removeListener(completeListener);
                    });//返回定位信息
                    var errorListener = AMap.event.addListener(geolocation, 'error', function (d) {
                        me.getLocalCity(error_CallBack)
                        AMap.event.removeListener(errorListener);
                    });     //返回定位出错信息
                }
            }, 200);
        }
    },
    getDistance: function (lng1, lat1, lng2, lat2) {
        //计算距离
        function rad(d) {
            return d * Math.PI / 180.0; //经纬度转换成三角函数中度分表形式。
        }
        var radLat1 = rad(lat1);
        var radLat2 = rad(lat2);
        var a = radLat1 - radLat2;
        var b = rad(lng1) - rad(lng2);
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
            Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * 6378.137; // EARTH_RADIUS;
        s = Math.round(s * 10000) / 10; //输出为公里
        if (s > 1000) {
            s = (s / 1000).toFixed(0) + 'km'
        } else {
            s = '<1km';
            // s = s.toFixed(0)+'m';
        }
        return s;
    },
    getDrivePath() {
        // 构造路线导航类
        const driving = new AMap.Driving({
            policy: AMap.DrivingPolicy.LEAST_TIME
        })

        // 根据起终点经纬度规划驾车导航路线
        driving.search(new AMap.LngLat(116.379028, 39.865042), new AMap.LngLat(116.427281, 39.903719), function (status, result) {
            if (status === 'complete') {
                if (result.routes && result.routes.length) {
                    const path = []
                    const route = result.routes[0]
                    for (let i = 0, l = route.steps.length; i < l; i++) {
                        const step = route.steps[i]
                        for (let j = 0, n = step.path.length; j < n; j++) {
                            path.push(step.path[j])
                        }
                    }
                }
            } else {
                console.log('获取驾车数据失败')
            }
        })
    }
}

export default mapUtil